import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

export type FlexProps = {
  children?: ReactNode;
} & BoxProps;

const Flex = (props: FlexProps) => {
  return (
    <Box display={"flex"} {...props}>
      {props?.children}
    </Box>
  );
};

export default Flex;
